/**
 * Small axios instance for anonymous public endpoints.
 * NO auth interceptor — a stray Bearer token must never be sent.
 */
import axios from 'axios';

const BASE = process.env.REACT_APP_BACKEND_URL || '';
const CANONICAL_URL = process.env.REACT_APP_CANONICAL_URL || null; // set later via env

const publicApi = axios.create({
  baseURL: `${BASE}/api`,
  headers: { 'Content-Type': 'application/json' },
});

export const publicAPI = {
  canonicalUrl: () => CANONICAL_URL,
  prospectMetadata: () => publicApi.get('/public/prospects/metadata'),
  submitProspect: (payload) => publicApi.post('/public/prospects', payload),
  submitAgentApplication: (payload) => publicApi.post('/public/agent-applications', payload),
  getApplicationStatus: (token) => publicApi.get(`/public/agent-applications/status/${token}`),
  listPublicEvents: (params = { window: 'upcoming', page: 1, page_size: 24 }) =>
    publicApi.get('/public/calendar/events', { params }),
  getPublicEvent: (id) => publicApi.get(`/public/calendar/events/${id}`),
  publicFlyerUrl: (id) => `${BASE}/api/public/calendar/events/${id}/flyer`,
  // Phase 26.2A — Anonymous public registration
  registerForPublicEvent: (id, payload) =>
    publicApi.post(`/public/calendar/events/${id}/register`, payload),
  // Phase 27.30.16 — Anonymous share-link registration
  getShareEvent: (token) => publicApi.get(`/public/events/share/${token}`),
  registerViaShareLink: (token, payload) =>
    publicApi.post(`/public/events/share/${token}/register`, payload),
};

export default publicAPI;
